const ChevronDown = ({ className }: { className?: string }) => (
    <span className={`material-symbols-rounded ${className}`}>expand_more</span>
);

export default ChevronDown;
